enum LevelEnum {
  STUDENT = '1'
}

export default LevelEnum
